<template>
  <ion-page>
    <Background></Background>
    <WhiteBackground></WhiteBackground>
    <FabColumn>
      <QuitButton content_1="您所輸入的資料將不會被保留。" content_2="是否確認退出重設密碼？"></QuitButton>
    </FabColumn>

    <ion-content>
      <MainTitle text="重設密碼"></MainTitle>
      <InputBox text="用戶名稱" :value="name" hideInput="true"></InputBox>
      <InputBox text="電話號碼" :value="showMobile" hideInput="true"></InputBox>
      <InputBox text="密碼" placeholder="6-18位英文或數字或符號" type="password" @getValue="getPasswordValue"></InputBox>
      <InputBox text="確認密碼" placeholder="請再次輸入密碼" type="password" @getValue="getConfirmPasswordValue"></InputBox>
      <ConfirmButton text="提交" position="relative" @click="resetPassword"></ConfirmButton>
    </ion-content>
  </ion-page>
</template>

<script>
import {IonContent, IonPage} from "@ionic/vue";
import Background from "../components/common/Background";
import WhiteBackground from "../components/common/WhiteBackground";
import QuitButton from "../components/common/QuitButton";
import MainTitle from "../components/common/MainTitle";
import ConfirmButton from "../components/common/ConfirmButton";
import common from "../common";
import router from "../router";
import InputBox from "../components/common/InputBox";

export default {
  name: "ResetPasswordByName",
  components: {
    InputBox,
    ConfirmButton,
    MainTitle,
    QuitButton,
    WhiteBackground,
    Background,
    IonPage,
    IonContent,
  },
  data() {
    return {
      mobile: '',
      name: '',
      showMobile: '',
      password: '',
      confirmPassword: '',
    }
  },
  mounted() {
    this.mobile = this.$route.params.mobile;
    this.showMobile = common.splitMobileEncrypt(this.mobile)
    this.name = this.$route.params.name;
  },
  methods: {
    getPasswordValue: function (value) {
      this.password = value;
    },
    getConfirmPasswordValue: function (value) {
      this.confirmPassword = value;
    },
    resetPassword: function () {
      if (this.password.trim().length === 0) {
        common.showAlert('請輸入密碼。')
        return false;
      }
      if (this.confirmPassword.trim().length === 0) {
        common.showAlert('請確認密碼。')
        return false;
      }
      if (this.password !== this.confirmPassword) {
        common.showAlert('密碼不一致，請重新輸入。')
        return false;
      }

      const loading = common.showLoading();
      common.apiPostData('/resetPassword', {mobile: this.mobile, name: this.name, password: this.password, confirm_password: this.confirmPassword}, false, loading).then(res => {
        if (res === false) {
          return false;
        }

        router.replace('/login')
      })
    }
  }
}
</script>

<style scoped>

</style>
